module.exports = __webpack_public_path__ + "img/icon_card.9e29bd80.svg";